var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeMaskBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 538,
    height: 608,
    viewBox: "0 0 538 608",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M746.136 263.733C740.305 170.694 695.083 82.7956 621.797 25.1479C555.554 -26.9591 465.208 -40.9763 383.125 -21.8151C314.915 -5.89279 290.651 73.2005 234.819 115.482C159.517 172.508 31.5492 172.799 6.06187 263.733C-20.7754 359.484 45.9076 460.346 119.367 527.394C189.938 591.806 287.57 606.669 383.125 607.888C480.293 609.127 583.191 601.057 653.701 534.211C725.592 466.054 752.331 362.584 746.136 263.733Z",
    fill: "#FFF2F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeMaskBg);
export default __webpack_public_path__ + "static/media/orange-mask-bg.96e0a7912d86564a4fb3b8f3fcdeb514.svg";
export { ForwardRef as ReactComponent };